import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement> & { size?: number }

function icon(paths: React.ReactNode, extra?: Partial<IconProps>) {
  return ({ size = 16, style, className, ...rest }: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      className={className}
      aria-hidden="true"
      {...extra}
      {...rest}
    >
      {paths}
    </svg>
  )
}

/** âœï¸ Edit / Pencil */
export const IconEdit = icon(<>
  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
</>)

/** ðŸ¢ Building / Company */
export const IconBuilding = icon(<>
  <path d="M3 21h18M9 21V7l6-4v18M9 7H3v14M15 11h2m-2 4h2" />
</>)

/** ðŸ‘¥ Users / Team */
export const IconUsers = icon(<>
  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
  <circle cx="9" cy="7" r="4" />
  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
</>)

/** ðŸ‘¤ User / Person */
export const IconUser = icon(<>
  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
  <circle cx="12" cy="7" r="4" />
</>)

/** ðŸ”‘ Key / Password */
export const IconKey = icon(<>
  <circle cx="7.5" cy="15.5" r="5.5" />
  <path d="M21 2 11.5 11.5" />
  <path d="M15.5 7.5 18 10" />
  <path d="M20 6l-2.5 2.5" />
</>)

/** ðŸ“§ Mail / Email */
export const IconMail = icon(<>
  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
  <polyline points="22,6 12,13 2,6" />
</>)

/** ðŸ” Lock / Secure */
export const IconLock = icon(<>
  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
</>)

/** âž• Plus / Add */
export const IconPlus = icon(<>
  <line x1="12" y1="5" x2="12" y2="19" />
  <line x1="5" y1="12" x2="19" y2="12" />
</>)

/** ðŸ—‘ï¸ Trash / Delete */
export const IconTrash = icon(<>
  <polyline points="3 6 5 6 21 6" />
  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
  <path d="M10 11v6M14 11v6" />
  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
</>)

/** âœ“ Check / Success */
export const IconCheck = icon(<>
  <polyline points="20 6 9 17 4 12" />
</>)

/** â† Arrow Left / Back */
export const IconArrowLeft = icon(<>
  <line x1="19" y1="12" x2="5" y2="12" />
  <polyline points="12 19 5 12 12 5" />
</>)

/** ðŸ“‹ Copy / Clipboard */
export const IconCopy = icon(<>
  <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
</>)

/** ðŸ”„ Refresh / Regenerate */
export const IconRefresh = icon(<>
  <polyline points="23 4 23 10 17 10" />
  <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
</>)

/** ðŸ“„ File Text / CSV */
export const IconFileText = icon(<>
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
  <polyline points="14 2 14 8 20 8" />
  <line x1="16" y1="13" x2="8" y2="13" />
  <line x1="16" y1="17" x2="8" y2="17" />
  <polyline points="10 9 9 9 8 9" />
</>)

/** ðŸ“Š Excel / Spreadsheet */
export const IconExcel = icon(<>
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
  <polyline points="14 2 14 8 20 8" />
  <path d="M9 12l4 4m0-4l-4 4" />
</>)

/** ðŸ§‘â€ðŸ’» Code / JSON */
export const IconCode = icon(<>
  <polyline points="16 18 22 12 16 6" />
  <polyline points="8 6 2 12 8 18" />
</>)

/** â¬‡ï¸ Download */
export const IconDownload = icon(<>
  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
  <polyline points="7 10 12 15 17 10" />
  <line x1="12" y1="15" x2="12" y2="3" />
</>)


/** ðŸ–¨ï¸ Printer / Print */
export const IconPrinter = icon(<>
  <polyline points="6 9 6 2 18 2 18 9" />
  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
  <rect x="6" y="14" width="12" height="8" />
</>)


/** ðŸ“• PDF File */
export const IconPDF = icon(<>
  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
  <polyline points="14 2 14 8 20 8" />
  <path d="M9 15v-4" />
  <path d="M12 15v-4c1.1 0 2 .9 2 2s-.9 2-2 2" />
  <path d="M15 11v4" />
  <path d="M15 13h2" />
  <path d="M17 11h-2" />
</>)

/** â˜€ï¸ Sun / Light Mode */
export const IconSun = icon(<>
  <circle cx="12" cy="12" r="5" />
  <line x1="12" y1="1" x2="12" y2="3" />
  <line x1="12" y1="21" x2="12" y2="23" />
  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
  <line x1="1" y1="12" x2="3" y2="12" />
  <line x1="21" y1="12" x2="23" y2="12" />
  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
</>)

/** ðŸŒ™ Moon / Dark Mode */
export const IconMoon = icon(<>
  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
</>)

/** ðŸ’» Monitor / System Theme */
export const IconMonitor = icon(<>
  <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
  <line x1="8" y1="21" x2="16" y2="21" />
  <line x1="12" y1="17" x2="12" y2="21" />
</>)

/** â— Chevron Left */
export const IconChevronLeft = icon(<>
  <polyline points="15 18 9 12 15 6" />
</>)

/** â–· Chevron Right */
export const IconChevronRight = icon(<>
  <polyline points="9 18 15 12 9 6" />
</>)

/** â‰ª Chevrons Left (Double) */
export const IconChevronsLeft = icon(<>
  <polyline points="11 17 6 12 11 7" />
  <polyline points="18 17 13 12 18 7" />
</>)

/** â‰« Chevrons Right (Double) */
export const IconChevronsRight = icon(<>
  <polyline points="13 17 18 12 13 7" />
  <polyline points="6 17 11 12 6 7" />
</>)

/** ðŸ‘ï¸ Eye / Show Password */
export const IconEye = icon(<>
  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
  <circle cx="12" cy="12" r="3" />
</>)

/** ðŸ™ˆ Eye Off / Hide Password */
export const IconEyeOff = icon(<>
  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
  <line x1="1" y1="1" x2="23" y2="23" />
</>)

/** ðŸ“± Smartphone / Mobile */
export const IconSmartphone = icon(<>
  <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
  <line x1="12" y1="18" x2="12.01" y2="18" />
</>)

/** ðŸ–¥ï¸ Server / Host */
export const IconServer = icon(<>
  <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
  <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
  <line x1="6" y1="6" x2="6.01" y2="6" />
  <line x1="6" y1="18" x2="6.01" y2="18" />
</>)

/** ðŸ›¡ï¸ Shield / Security */
export const IconShield = icon(<>
  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
</>)

/** ðŸŽ¨ Palette / Branding */
export const IconPalette = icon(<>
  <circle cx="13.5" cy="6.5" r=".5" />
  <circle cx="17.5" cy="10.5" r=".5" />
  <circle cx="8.5" cy="7.5" r=".5" />
  <circle cx="6.5" cy="12.5" r=".5" />
  <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
</>)

/** ðŸ“¤ Send / Airplane */
export const IconSend = icon(<>
  <line x1="22" y1="2" x2="11" y2="13" />
  <polygon points="22 2 15 22 11 13 2 9 22 2" />
</>)

/** â„¹ï¸ Info */
export const IconInfo = icon(<>
  <circle cx="12" cy="12" r="10" />
  <line x1="12" y1="16" x2="12" y2="12" />
  <line x1="12" y1="8" x2="12.01" y2="8" />
</>)

/** âš ï¸ Alert Circle */
export const IconAlertCircle = icon(<>
  <circle cx="12" cy="12" r="10" />
  <line x1="12" y1="8" x2="12" y2="12" />
  <line x1="12" y1="16" x2="12.01" y2="16" />
</>)

/** âœ… Check Circle */
export const IconCheckCircle = icon(<>
  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
  <polyline points="22 4 12 14.01 9 11.01" />
</>)

/** ðŸ’¬ Message Circle / WhatsApp */
export const IconMessageCircle = icon(<>
  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
</>)

/** ðŸ QR Code */
export const IconQrCode = icon(<>
  <rect x="3" y="3" width="7" height="7" />
  <rect x="14" y="3" width="7" height="7" />
  <rect x="3" y="14" width="7" height="7" />
  <rect x="14" y="14" width="7" height="7" />
  <line x1="7" y1="7" x2="7.01" y2="7" />
  <line x1="17" y1="7" x2="17.01" y2="7" />
  <line x1="7" y1="17" x2="7.01" y2="17" />
  <line x1="17" y1="17" x2="17.01" y2="17" />
</>)

/** â» Power / Disconnect */
export const IconPower = icon(<>
  <path d="M18.36 6.64a9 9 0 1 1-12.73 0" />
  <line x1="12" y1="2" x2="12" y2="12" />
</>)

/** â†’ Arrow Right */
export const IconArrowRight = icon(<>
  <line x1="5" y1="12" x2="19" y2="12" />
  <polyline points="12 5 19 12 12 19" />
</>)

/** ðŸ” Search */
export const IconSearch = icon(<>
  <circle cx="11" cy="11" r="8" />
  <line x1="21" y1="21" x2="16.65" y2="16.65" />
</>)

/** ðŸ”½ Filter */
export const IconFilter = icon(<>
  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
</>)

/** â†— External Link */
export const IconExternalLink = icon(<>
  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
  <polyline points="15 3 21 3 21 9" />
  <line x1="10" y1="14" x2="21" y2="3" />
</>)

/** ðŸ§¾ Receipt / Faturamento / HonorÃ¡rios */
export const IconReceipt = icon(<>
  <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z" />
  <line x1="8" y1="7" x2="16" y2="7" />
  <line x1="8" y1="11" x2="16" y2="11" />
  <line x1="8" y1="15" x2="13" y2="15" />
</>)

/** âš™ï¸ Settings / Sliders */
export const IconSettings = icon(<>
  <circle cx="12" cy="12" r="3" />
  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
</>)

/** Sliders / Controls / Customize */
export const IconSliders = icon(<>
  <line x1="4" y1="21" x2="4" y2="14" />
  <line x1="4" y1="10" x2="4" y2="3" />
  <line x1="12" y1="21" x2="12" y2="12" />
  <line x1="12" y1="8" x2="12" y2="3" />
  <line x1="20" y1="21" x2="20" y2="16" />
  <line x1="20" y1="12" x2="20" y2="3" />
  <line x1="1" y1="14" x2="7" y2="14" />
  <line x1="9" y1="8" x2="15" y2="8" />
  <line x1="17" y1="16" x2="23" y2="16" />
</>)

/** ðŸ’³ Credit Card */
export const IconCreditCard = icon(<>
  <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
  <line x1="1" y1="10" x2="23" y2="10" />
</>)

/** ðŸ“… Calendar */
export const IconCalendar = icon(<>
  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
  <line x1="16" y1="2" x2="16" y2="6" />
  <line x1="8" y1="2" x2="8" y2="6" />
  <line x1="3" y1="10" x2="21" y2="10" />
</>)

/** 💲 Dollar / Financial */
export const IconDollarSign = icon(<>
  <line x1="12" y1="1" x2="12" y2="23" />
  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
</>)

/** Close / X */
export const IconX = icon(<>
  <line x1="18" y1="6" x2="6" y2="18" />
  <line x1="6" y1="6" x2="18" y2="18" />
</>)

/** Clipboard List - onboarding management */
export const IconClipboardList = icon(<>
  <rect x="9" y="2" width="6" height="4" rx="1" ry="1" />
  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
  <line x1="9" y1="12" x2="15" y2="12" />
  <line x1="9" y1="16" x2="13" y2="16" />
</>)

/** Clipboard Check - review action */
export const IconClipboardCheck = icon(<>
  <rect x="9" y="2" width="6" height="4" rx="1" ry="1" />
  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
  <polyline points="9 13 11 15 15 10" />
</>)

/** Globe - access configuration */
export const IconGlobe = icon(<>
  <circle cx="12" cy="12" r="10" />
  <line x1="2" y1="12" x2="22" y2="12" />
  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
</>)

/** Link - copy link action */
export const IconLink = icon(<>
  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
</>)

/** Rotate Counter-Clockwise / Reset Session */
export const IconRotateCcw = icon(<>
  <polyline points="1 4 1 10 7 10" />
  <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
</>)

/** User Check / User Verified */
export const IconUserCheck = icon(<>
  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
  <circle cx="9" cy="7" r="4" />
  <polyline points="16 11 18 13 22 9" />
</>)

/** Barcode / Boleto */
export const IconBarcode = icon(<>
  <path d="M3 5v14" />
  <path d="M8 5v14" />
  <path d="M12 5v14" />
  <path d="M17 5v14" />
  <path d="M21 5v14" />
</>)

/** Arrow Up Right / TED / Transferencia */
export const IconArrowUpRight = icon(<>
  <line x1="7" y1="17" x2="17" y2="7" />
  <polyline points="7 7 17 7 17 17" />
</>)

/** Shield Check / Autorizacao Segura */
export const IconShieldCheck = icon(<>
  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  <polyline points="9 12 11 14 15 10" />
</>)

/** Refresh CW / Sincronizacao de Saldos */
export const IconRefreshCw = icon(<>
  <polyline points="23 4 23 10 17 10" />
  <polyline points="1 20 1 14 7 14" />
  <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
</>)

/** Payments / Cartao / Pagamentos */
export const IconPayments = icon(<>
  <path d="M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2" />
  <path d="M3 10h18" />
  <path d="M16 14h2" />
  <path d="M10 14H6" />
</>)

/** History / Historico */
export const IconHistory = icon(<>
  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
  <path d="M3 3v5h5" />
  <path d="M12 7v5l4 2" />
</>)

/** Clock / Relogio / Tempo */
export const IconClock = icon(<>
  <circle cx="12" cy="12" r="10" />
  <polyline points="12 6 12 12 16 14" />
</>)




